import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { cancelScaleFloorPlanAction } from 'actions/floorPlanActions'
import { messageAction } from 'actions/messageActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import VideoPanel from 'components/VideoPanel'

const mapStateToProps = ({ map: { floorPlans }, ui: { scaling, floorPlanScaleID } }) => {
  const currentFloorplan = floorPlans.find(f => f.id === floorPlanScaleID)

  return { currentFloorplan, scaling }
}

class FloorPlanScaler extends React.Component {
  constructor() {
    super()
    this.state = { unit: 'Feet' }
  }

  complete() {
    const { state: { unit }, props: { currentFloorplan: { overlay, scaler },
      messageAction, cancelScaleFloorPlanAction } } = this
    let width = this.refs.width.value
    const distance = scaler.getDistance()

    if ((width === undefined) || (width.length === 0) || !width.trim()) {
      return messageAction('generalError', 'Must enter width to scale floorplan.')
    }

    width = parseFloat(width)
    if (isNaN(width) || (width < 1)) {
      return messageAction('generalError', 'Please enter a valid width.')
    }

    if (unit === 'Feet') width = width * 0.3048
    overlay.resizeByScale(width / distance)
    cancelScaleFloorPlanAction()
  }

  render() {
    const { currentFloorplan, scaling, cancelScaleFloorPlanAction, classes } = this.props

    if (!currentFloorplan || !scaling) return null

    return (
      <div className={classes.floorPlanScaler}>
        <div className={classes.topUiControls}>
          <a onClick={_ => cancelScaleFloorPlanAction()}>
            <FontAwesomeIcon icon='caret-left' className={classes.goBackButton} />
            Floor Plan
          </a>
        </div>
        <div className={classes.label}>Scale Floor Plan</div>
        <ol className={classes.instructionList}>
          <li>Find a known distance shown on the floor plan, e.g., 3 ft wide door, 9 ft wide parking space, etc.</li>
          <li>Adjust the green bar on the map to that distance</li>
          <li>Enter that value:</li>
        </ol>
        <input
          onClick={_ => this.refs.width.focus()}
          className={classes.widthInput}
          ref='width'
          placeholder='Distance'
        />
        <label htmlFor='Feet' className={classes.feetButton} style={{ display: 'inline', marginRight: '.5rem', fontWeight: 300 }}>
          <input onClick={_ => this.setState({ unit: 'Feet' })} defaultChecked ref='feet' type='radio' name='UOM' value='Feet' style={{ marginRight: '.5rem' }} />
          Feet
        </label>
        <label htmlFor='Meters' className={classes.meterButton} style={{ display: 'inline', fontWeight: 300 }}>
          <input onClick={_ => this.setState({ unit: 'Meter' })} ref='meter' type='radio' name='UOM' value='Meter' style={{ marginRight: '.5rem' }} />
          Meters
        </label>
        <div className={classes.buttonWrapper}>
          <a onClick={this.complete.bind(this)} className={classes.scaleButton}>
            <FontAwesomeIcon icon='expand-arrows-alt' className={classes.scaleIcon} />Scale Floor Plan
          </a>
          <a onClick={_ => cancelScaleFloorPlanAction()} className={classes.cancelButton}>Cancel</a>
        </div>
        <div className={classes.spacer} />
        <VideoPanel
          videoUrl='https://www.youtube.com/embed/8SffVlj03vY?rel=0&showinfo=0'
          uiKey='scalingVideoPanelOpen'
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, { cancelScaleFloorPlanAction, messageAction })(injectSheet(style)(FloorPlanScaler))



// WEBPACK FOOTER //
// ./src/components/FloorPlan/FloorPlanScaler/index.js